import c from "./Loading.module.css";

const Loading = (p) => {
  return (
    <div className={c.wrapper}>
      <div className={c["loadingio-spinner-double-ring-edv86u374f9"]}>
        <div className={c["ldio-aqd28adx82o"]}>
          <div></div>
          <div></div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default Loading;